import { ThemeProvider } from '@mui/material'
import { MainTemplate } from 'Components/Template/MainTemplate'
import { observer } from 'mobx-react-lite'
import MaintenanceElem from 'Components/Elements/Maintenance/Maintenance'
import { storeElement } from 'GlobalStores/StoreElement'

const SignUp = observer(() => {

    return (
        <ThemeProvider theme={storeElement.theme}>
            <MaintenanceElem />
        </ThemeProvider>
    )
})

export default SignUp
